package com.cybersoftsolution.cybersoftsolutionweb.components.carousel

import androidx.compose.runtime.Composable
import androidx.compose.runtime.*
import com.cybersoftsolution.cybersoftsolutionweb.models.MyElement
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*
import com.cybersoftsolution.cybersoftsolutionweb.styles.HalfBlackButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.cybersoftsolution.cybersoftsolutionweb.utils.contentRectElementObserver
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TouchAction
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.UserSelect
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.asSharedFlow
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement

object BiggerHeight{
    private val _biggest = MutableSharedFlow<Pair<String, Int>>(replay = 1)  // Canal para comunicar cambios
    val biggestFlow = _biggest.asSharedFlow()
    private val heightObservers = mutableMapOf<String, Int>()
    var recalculate =0

    private fun recalculateHeight() {
        var newBigOne = Pair("",0)
        heightObservers.forEach { (id, height) ->
            if (height > newBigOne.second) {newBigOne=Pair(id,height)}
        }
        _biggest.tryEmit(newBigOne)
    }


    fun updateElementHeight(id: String, height: Int) {
        recalculate++
        heightObservers[id] = height
        if (recalculate == 5) {
            recalculateHeight()
            recalculate = 0
        }

    }

}

@Composable
inline fun <reified T : MyElement>MyVerticalCarousel(
    id: String,
    modifier: Modifier = Modifier,
    elements: List<T>,
    slideShow: Boolean = true,
    pauseSlideShow: Boolean = false,
    previewButtonText: String? = null,
    nextButtonText: String? = null,
    slideDurationInSeconds: Int = 3,
    animationDurationInMilliseconds: Number = 500,
    initIndex: Int = 0,
    crossinline onForceToContinue: () -> Unit = {},
    crossinline onResponsiveWidthChange: (Int?) -> Unit = {} ,
    useCustomNavigator: Boolean = false,
    crossinline navigatorItem: @Composable (T) -> Unit = {},
    crossinline content: @Composable (T) -> Unit
) {
    var currentIndex by remember { mutableStateOf(initIndex) }
    var responsiveWidth by remember { mutableStateOf(0) }
    var responsiveHeight by remember { mutableStateOf(0) }
    var pause by remember { mutableStateOf(pauseSlideShow) }

    val breakpoint = rememberBreakpoint()

    //Para pausar el carrusel desde afuera
    LaunchedEffect(pauseSlideShow) {
        pause = pauseSlideShow
    }


    //Libreria externa para el swipe horizontal en el carrusel
    var hammerInitialized by remember { mutableStateOf(false) }

    //Inicializar la libreria externa para el swipe Vertical en el carrusel
    LaunchedEffect(responsiveWidth) {
        if (!hammerInitialized) {
            val carouselDiv = document.getElementById(id) as? HTMLElement
            if (carouselDiv != null) {
                val hammerTime = js("new Hammer(carouselDiv)")

                hammerTime.get("swipe").set(js("{ direction: Hammer.DIRECTION_VERTICAL }")) // Configurar solo swipe horizontal

                hammerTime.on("swipeup", { dynamic ->
                    currentIndex = (currentIndex + 1) % elements.size
                    dynamic
                })
                hammerTime.on("swipedown", { dynamic ->
                    currentIndex = (currentIndex - 1 + elements.size) % elements.size
                    dynamic
                })
                hammerInitialized = true
            }
        }
    }

    //Autoplay del carrusel cuando se inicia la pagina y pausar si hace falta
    LaunchedEffect(Unit,currentIndex,pause) {
        if (slideShow && !pause) {
            delay(slideDurationInSeconds * 1000L)
            currentIndex = (currentIndex + 1) % elements.size
        }
    }


    LaunchedEffect(Unit,breakpoint) {
        //Obtener el ancho del elemento por primera vez
        responsiveWidth = (document.getElementById(id) as? HTMLDivElement)?.offsetWidth ?: 0


        //Obtener el alto del elemento por primera vez
        responsiveHeight = ((document.getElementById("${elements[currentIndex].id.orEmpty()}ContainerId") as? HTMLDivElement)?.offsetHeight ?: 0)


        //Observar el ancho del elemento
        contentRectElementObserver.observeElementById(id)


        contentRectElementObserver.contentSizeFlow.collect { (idObserve, contentSize) ->
            responsiveHeight = ((document.getElementById("${elements[currentIndex].id.orEmpty()}ContainerId") as? HTMLDivElement)?.offsetHeight ?: 0)
            when (idObserve) {
                id -> {
                    responsiveWidth = contentSize.width.toInt()
                }
            }
        }



    }


    // ... DisposableEffect para dejar de observar el ancho del elemento
    DisposableEffect(Unit) {
        onDispose {
            contentRectElementObserver.unObserveElementById(id)
        }
    }

    //Detectar cambios en el ancho del elemento
    LaunchedEffect(responsiveWidth) {
        onResponsiveWidthChange(responsiveWidth)
    }

    //Al Deslizar el carusel por cualquier via despausar el autoplay
    LaunchedEffect(currentIndex) {
        pause = false
        onForceToContinue()
    }

    Div(
        attrs = Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Row)
            .toAttrs()

    ) {

        Column(

            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.SpaceEvenly,
            modifier = Modifier
                .fillMaxHeight()
                .thenIf(
                    condition = !useCustomNavigator,
                    other = Modifier.width(0.px)
                )
                .visibility(if (useCustomNavigator) Visibility.Visible else Visibility.Hidden)
        ){
            elements.forEachIndexed { index, element ->
                Div(
                    //SelectionEffect
                    attrs = Modifier
                        .transition(Transition.of(property = TransitionProperty.All, duration = animationDurationInMilliseconds.ms))
                        .borderRadius(365.px)
                        .thenIf(
                            condition =  currentIndex == index,
                            other = Modifier
                                .boxShadow(
                                    blurRadius = (3).px,
                                    spreadRadius = (3).px,
                                    color = Theme.Primary.rgb
                                )

                        )
                        .cursor(Cursor.Pointer)
                        .onClick { currentIndex = index }
                        .toAttrs()
                ) {
                    navigatorItem(element)

                }

            }
        }

        Div(
            attrs =  modifier
                .id(id)

                .height(responsiveHeight.px)
                .flexGrow(1) // El segundo elemento crece para ocupar el espacio restante
                .touchAction(TouchAction.PanY)
                .overflow(Overflow.Hidden)
                .position(Position.Relative)
                .cursor(Cursor.Pointer)
                .userSelect(UserSelect.None)
                .transition(Transition.of(property = TransitionProperty.All, duration = animationDurationInMilliseconds.ms))
                .toAttrs()
        ) {
            Div(
                attrs =  Modifier
                    .display(DisplayStyle.ListItem)
                    .flexWrap(FlexWrap.Nowrap)
                    .transition(
                        Transition.of(
                            property = TransitionProperty.of("transform"), // Corrección: usar of("transform")
                            duration = animationDurationInMilliseconds.ms, // Duración de la transición
                            timingFunction = TransitionTimingFunction.EaseInOut, // Función de tiempo
                            delay = null
                        )
                    )
                    .onTransitionStart {
                        responsiveHeight = ((document.getElementById("${elements[currentIndex].id.orEmpty()}ContainerId") as? HTMLDivElement)?.offsetHeight ?: 0)
                    }
//                .onTransitionEnd {
//                    responsiveHeight = ((document.getElementById("${elements[currentIndex].id.orEmpty()}ContainerId") as? HTMLDivElement)?.offsetHeight ?: 0)
//                }
                    .transform {

                        translateY(-(((document.getElementById("${elements[currentIndex].id.orEmpty()}ContainerId") as? HTMLDivElement)?.offsetTop)?:0) .px)
//                    translateY((-currentIndex * responsiveHeight).px)
                    }
                    .toAttrs()
            ) {
                elements.forEach { element ->
                    Div(
                        attrs = Modifier
                            .id("${element.id.orEmpty()}ContainerId")
                            .width(responsiveWidth.px)
                            .flexShrink(0)
                            .padding(10.px)
                            .toAttrs()


                    ) {
                        content(element)
                    }

                }
            }

            previewButtonText?.let {
                Button(
                    attrs = HalfBlackButtonStyle.toModifier()
                        .visibility(if (useCustomNavigator) Visibility.Hidden else Visibility.Visible)
                        .position(Position.Absolute)
                        .top(0.px)
//                    .transform { // Usar el bloque transform {}
//                        translateY((-50).percent) // translateY acepta CSSPercentageValue
//                    }
//                    .padding(10.px, 20.px)
                        .margin(5.px)
                        .scale(1.5)
                        .border(0.px)
                        .thenIf(
                            condition = previewButtonText == nextButtonText,
                            other = Modifier
                                .rotate((-90).deg)
                        )
                        .left(50.percent)
                        .onClick { currentIndex = (currentIndex - 1 + elements.size) % elements.size }
                        .toAttrs()

                ) { Text(it) }
            }

            nextButtonText?.let {
                Button(
                    attrs = HalfBlackButtonStyle.toModifier()
                        .visibility(if (useCustomNavigator) Visibility.Hidden else Visibility.Visible)
                        .position(Position.Absolute)
                        .bottom(0.px)
//                    .transform { // Usar el bloque transform {}
//                        translateY((-50).percent) // translateY acepta CSSPercentageValue
//                    }
//                    .padding(10.px, 20.px)
                        .margin(5.px)
                        .scale(1.5)
                        .border(0.px)
                        .thenIf(
                            condition = previewButtonText == nextButtonText,
                            other = Modifier
                                .rotate((90).deg)
                        )
                        .left(50.percent)
                        .onClick { currentIndex = (currentIndex + 1) % elements.size }
                        .toAttrs()
                ) { Text(it) }
            }


            //Actualizar el ancho del elemento cuando se terminan de cargar los elementos
            onResponsiveWidthChange(responsiveWidth)

        }




    }




}
